/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Permissions_Select_AllInputs */

const vi_api_keys_permissions_select_all = /** @type {(inputs: Api_Keys_Permissions_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn tất cả`)
};

/**

* @param {Api_Keys_Permissions_Select_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permissions_select_all = /** @type {((inputs?: Api_Keys_Permissions_Select_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Permissions_Select_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permissions_select_all(inputs)
});